import {
    findIn,
    on,
    findAllIn,
    hasClass
} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-checkbox-list', (container) => {
       let list = findIn('.js-checkbox-list__list', container);

       findAllIn('.js-checkbox-list__item', list).forEach( (item) => {
          let checkbox = findIn('.js-checkbox-list__checkbox', item);

          on('click', () => {
              if(checkbox.checked){
                  if(hasClass('js-checkbox-list__item--all', item)){
                      findAllIn('.js-checkbox-list__checkbox', list).forEach((element) => {
                          element.checked = true;
                      });
                  }
                  else if(findIn('.js-checkbox-list__list', item)){
                      findAllIn('.js-checkbox-list__checkbox', item).forEach((element) => {
                          element.checked = true;
                      });
                  }
              }
              else{
                  if(hasClass('js-checkbox-list__item--all', item)){
                      findAllIn('.js-checkbox-list__checkbox', list).forEach((element) => {
                          element.checked = false;
                      });
                  }
                  else if(findIn('.js-checkbox-list__list', item)){
                      findAllIn('.js-checkbox-list__checkbox', item).forEach((element) => {
                          element.checked = false;
                      });
                  }
                  else{
                      checkbox.checked = false;
                  }
              }

              syncAllCheckbox(list);
              updateCount(container, list);
          }, checkbox);

       });

       on('change', () => {
           syncAllCheckbox(list);
           updateCount(container, list);
       }, container);

       syncAllCheckbox(list);
       updateCount(container, list);
    });
}

function syncAllCheckbox(list) {
    let items = findAllIn('.js-checkbox-list__item', list);

    let allCheckbox = items
        .filter((item) => hasClass('js-checkbox-list__item--all', item))
        .map((item) => findIn('.js-checkbox-list__checkbox', item))[0];

    if(!allCheckbox){
        return;
    }

    let itemCheckboxes = items
        .filter((item) => !hasClass('js-checkbox-list__item--all', item))
        .map((item) => findIn('.js-checkbox-list__checkbox', item))
        .filter((itemCheckbox) => itemCheckbox);

    allCheckbox.checked = itemCheckboxes.length > 0 && itemCheckboxes.every((itemCheckbox) => itemCheckbox.checked);
}

function updateCount(container, list) {
    let checkedCheckboxes = findAllIn('.js-checkbox-list__item', list)
        .filter((item) => !hasClass('js-checkbox-list__item--all', item))
        .map((item) => findIn('.js-checkbox-list__checkbox', item))
        .filter((checkbox) => checkbox && checkbox.checked);

    let countElement = findIn('.js-checkbox-list__count', container);
    if(countElement){
        countElement.textContent = checkedCheckboxes.length;
    }

    let submitButton = findIn('.js-checkbox-list__submit', container);
    if(submitButton){
        submitButton.disabled = checkedCheckboxes.length === 0;
    }

    let totalElement = findIn('.js-checkbox-list__total', container);
    if(totalElement){
        let total = checkedCheckboxes.reduce((sum, checkbox) => sum + parseFloat(checkbox.getAttribute('data-price') || 0), 0);
        let currency = container.getAttribute('data-currency');
        let locale = container.getAttribute('data-locale');

        totalElement.textContent = new Intl.NumberFormat(locale || undefined, {style: 'currency', currency: currency || 'EUR'}).format(total);
    }
}
